/* Doggivelle Luxe — motion layer */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (root.classList.contains('shopify-design-mode') || reduce) return;
  root.classList.add('luxe-js');

  function init() {
    // Scroll progress line
    var bar = document.createElement('div');
    bar.className = 'luxe-progress';
    document.body.appendChild(bar);

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        var p = h > 0 ? window.scrollY / h : 0;
        bar.style.transform = 'scaleX(' + p + ')';
        root.classList.toggle('luxe-scrolled', window.scrollY > 40);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Scroll reveal for sections and cards (skip the first section so the hero is instant)
    var targets = [];
    document.querySelectorAll('#MainContent > .shopify-section').forEach(function (s, i) {
      if (i > 0) targets.push(s);
    });
    document.querySelectorAll('product-card, .product-card, .resource-list__item, .collection-card').forEach(function (c) {
      targets.push(c);
    });
    document.querySelectorAll('footer .shopify-section').forEach(function (s) { targets.push(s); });

    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    targets.forEach(function (el) {
      // Stagger siblings inside grids
      var parent = el.parentElement;
      if (parent && (el.matches('product-card, .product-card, .resource-list__item, .collection-card'))) {
        var sibs = Array.prototype.filter.call(parent.children, function (n) { return n === el || n.matches && n.matches('product-card, .product-card, .resource-list__item, .collection-card'); });
        var idx = sibs.indexOf(el);
        el.style.setProperty('--luxe-delay', (Math.max(0, idx) % 6) * 0.12 + 's');
      }
      el.classList.add('luxe-reveal');
      io.observe(el);
    });

    // Fail-safe: never leave content hidden
    setTimeout(function () {
      document.querySelectorAll('.luxe-reveal:not(.is-visible)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) el.classList.add('is-visible');
      });
    }, 2500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
